const URLs = {
  local: 'http://localhost:8000',
  development: 'https://development.v2.chameleoncreator.com',
  staging: 'https://staging.v2.chameleoncreator.com',
  production: 'https://v2.chameleoncreator.com',
  anz: "https://anz.v2.chameleoncreator.com"
};

function getParams() {
  var qu = window.location.href.split('?')[1];
  var data = {} as any;


  if (!qu) {
    var env = window.env || 'local';

    return {
      hasRemote: false,
      projectId: window.projectId || '-1',
      url: URLs[env.toLowerCase()] || URLs.local,
      hosted: window.hosted == true,
      mode: window.mode || 'DEVELOPMENT',
    };
  } else {
    var params = qu.split('&');

    for (var x in params) {
      data[params[x].split('=')[0]] = params[x].split('=')[1];
    }

    var env = data.env || 'local';

    return {
      hasRemote: true,
      projectId: window.projectId || data.project_id || '1',
      url: URLs[env.toLowerCase()] || URLs.local,
      mode: window.mode || data.mode,
      hosted: window.hosted == true || data.hosted == 'true',
    };
  }
}

window.chameleon = {
  CHAMELEON_URL: getParams().url,
};

window.hasMode = mode => {
  const windowMode = getParams().mode || 'DEVELOPMENT';

  return mode === windowMode;
};

window.getParams = getParams;
